module.exports = __webpack_public_path__ + "img/Total-Outstanding.c5246d95.svg";